var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"seacher-bar"},[_c('input',{staticClass:"search-input",attrs:{"type":"text","placeholder":"您想找哪位教師？"}}),_c('div',{staticClass:"search-img"},[_c('img',{attrs:{"src":require("@/assets/images/ic-search@3x.png")}})])])
}]

export { render, staticRenderFns }